/**
 * Created by Alex on 12/18/2024.
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { AppendEntitiesDialogComponent } from './append-entities-dialog.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TemplateModule } from '../template/template.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        DropDownsModule,
        TemplateModule,
    ],
    declarations: [
        AppendEntitiesDialogComponent,
    ],
    exports: [
        AppendEntitiesDialogComponent,
    ],
    providers: []
})
export class AppendEntitiesDialogModule {
}
